<template>
  <div class="ecommerce" :class="{ 'bg-red': isPaused }" v-if="role" :key="z">
    <div class="wrapper" :class="{ 'wrapper-border': width > 600 }" @click.once="sendTestNotification">
      <MainBackButton :forceHome="true" />

      <OrderDetailsCommerceAgent v-if="selected" :t="selected" :completedItems="completedItems"
        @toggleItemComplete="toggleItemComplete" @close="selected = null" />

      <CommerceSettings ref="settings" v-if="showSettings" @close="showSettings = false" />

      <MembershipProgram v-if="showMembers" :w="workflow" @close="showMembers = false" />

      <ChangeCommerceAgent v-if="showChangeShop" @close="showChangeShop = false" @changed="updateOrdersCommerceAgent" />

      <div class="top-bar" :style="themeBgColor" />
      <p class="header-row" :style="themeColor">
        <span class="header no-scrollbar">
          {{ role.business.name }}
        </span>
        <span class="icon is-pulled-right more-btn" style="padding: 15px; margin-right: 10px; height: 56px"
          @click="showSidebar = true">
          <i class="fa fa-ellipsis-v fa-lg" />
        </span>
      </p>

      <div class="hours-wrapper">
        <span class="open-hours no-scrollbar">
          <i class="far fa-clock" style="opacity: 0.8; margin-right: 6px" @click="hoursDebug" />
          <span :class="openClosed.class">{{ openClosed.text }}</span>

          <!-- <span style="margin-left: 4px" @click="openCommerceSettings"> -->
          <span style="margin-left: 4px" @click="gotoHours">
            <span v-if="closedUntil" class="closed-until">{{ $t("until") }} {{ closedUntil }}</span>
            <span v-else class="has-text-grey">{{ $t("today") }} <span class="link">{{ todaysHours }}</span>
            </span>
          </span>
        </span>
        <span class="button is-small is-white is-rounded is-pulled-right oos-btn" @click="goto('menu_editor')">
          {{ $t("commerce.out-of-stock") }}
          <span v-if="outOfStockCount" class="oos-cnt">{{
            outOfStockCount
          }}</span>
          <span v-else class="oos-cnt" style="background-color: #35ac5e">0</span>
        </span>
      </div>

      <div v-if="isPaused" class="notification paused" @click="preTogglePause">
        <i class="fa fa-play-circle" />&nbsp;
        {{ $t("pause-shop.un-pause") }}
        <span class="is-pulled-right">
          <i class="fa fa-play pulse-orange" style="margin-left: 6px" />
        </span>
      </div>

      <div v-if="isDifferentTimezone" class="notification is-warning">
        <i class="fa fa-globe-asia" />&nbsp; Device timezone
        <b>{{ deviceTimezone }}</b> is different from your shop
      </div>

      <div v-if="showFBAdsCallout" class="notification pulse-background" @click="openFBAdsInfo">
        <i class="fab fa-facebook has-text-link" />&nbsp;
        {{ $t("Facebook Ads") }}
        <i class="fa fa-chevron-right has-text-black is-pulled-right" style="margin-left: 8px; padding: 3px 0" />
        <br />
        <i> Get your June <strong>FREE CREDIT!</strong> </i>
        <span class="link-dark is-pulled-right" style="font-weight: 500; opacity: 0.6">
          Try it!
        </span>
      </div>

      <div v-if="showBilling && hasBilling" class="notification is-orange billing-btn" @click="gotoBilling">
        <i class="fa fa-file-invoice" />&nbsp;
        {{ $t("billing.your-bill-is-ready") }}: 1-30 SEP 2023
        <i class="fa fa-info-circle is-pulled-right" style="padding: 3px 0" />
        <div>
          <p v-if="billingEmail" class="billing-check-email">
            <marquee-text :duration="18">
              {{ $t("billing.please-check-email") }} <a>{{ billingEmail }}</a>
              {{ $t("billing.for-tuk-invoice") }}.
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </marquee-text>
          </p>
          <p v-else class="has-text-danger" @click="contactMerchantSupport()">
            PLEASE contact TUK to fix your billing email!
            <a class="has-text-link">
              Message us now <i class="fa fa-chevron-right" />
            </a>
          </p>
        </div>
      </div>

      <div v-if="!showNotificationsHint && !$store.getters.getNotificationToken" class="notification is-danger no-radius"
        @click="notify">
        <i class="fa fa-exclamation-triangle" />&nbsp; Please check app
        notification permissions
      </div>

      <div v-if="commerceAgentMessage" class="notification is-danger no-radius" @click="contactMerchantSupport()">
        <i class="fa fa-bullhorn" />&nbsp;
        {{ commerceAgentMessage }}
        <a class="has-text-warning">Contact us <i class="fa fa-chevron-right" /></a>
      </div>

      <div v-if="business.data.hidden" class="notification is-warning no-radius" @click="infoHiddenShop">
        <i class="fa fa-eye-slash" />&nbsp;Shop is hidden
        <i class="fa fa-info-circle is-pulled-right" style="padding: 3px 0" />
      </div>

      <fade-transition>
        <div v-if="showNotificationsHint" class="notification is-info test-notification">
          <p>A test push notification has been sent to this device:</p>
          <p><i class="has-text-weight-bold">Hi from TUK</i> 👍🏼</p>
          <p>
            If you do not receive it please check that you have enabled push
            notifications for both TUK App and Chrome or Samsung Internet
            Browser in your system settings.
          </p>
          <p>
            If you are logged in to multiple devices with the same user account
            you will only receive notifications to one of them.
          </p>
          <p>
            If you are still not able to receive notifications please contact
            the TUK team for technical support.
          </p>
          <a class="button is-warning" href="https://m.me/tukapp" target="_blank">
            Contact TUK
          </a>
          <a class="button is-white is-pulled-right" @click="showNotificationsHint = false">
            Dismiss
          </a>
        </div>
      </fade-transition>

      <div class="no-scrollbar gpu-accelerated" style="overflow: scroll; height: calc(100vh - 110px)">
        <div class="orders-header">
          <span class="is-size-5" @click="updateOrdersCommerceAgent(true)">
            <i class="fa fa-bell pad" />
            {{ $t("ecommerce.new-orders") }}
            <span v-show="isUpdating" style="margin-left: 6px">
              <i class="fa fa-spinner fa-spin fa-sm has-text-info" />
            </span>
          </span>
          <span v-if="!isPaused" class="pause-btn" @click="preTogglePause">
            <!-- <span v-if="isPaused" class="un-pause">
                  {{ $t("pause-shop.un-pause") }}
                  <i class="fa fa-play-circle pulse" />
                </span> -->
            <span class="link"> {{ $t("pause-shop.pause") }}? </span>
          </span>
        </div>

        <!------------ New Orders ------------>
        <div v-if="!newOrders.length" class="notification is-white is-size-5 none"
          @click="updateOrdersCommerceAgent(true)">
          <span v-if="isUpdating"><b-skeleton active height="30px" /></span>
          <!-- <span v-if="isUpdating" class="has-text-info"
                >{{ $t("updating") }}...</span
              > -->
          <span v-else>{{ $t("none") }}</span>
        </div>
        <div class="transaction" :style="newOrderStyle(t)" v-for="t in newOrders" :key="t.id"
          @click="openOrderDetails(t)">
          <div class="columns is-mobile is-vcentered">
            <div class="column is-narrow ticket">
              <p v-if="isTest(t)" class="test">TEST</p>
              <p class="is-size-3">{{ ref(t) }}</p>
              <i class="fa is-size-4" :class="fulfilmentIcon(t)" />
            </div>
            <div class="column middle">
              <div class="has-text-left">
                <p>
                  <i class="fa fa-user pad" />
                  {{ customerName(t) }}
                </p>
                <p>
                  <i class="far fa-clock pad" />
                  {{ $t("ecommerce.ordered") }}
                  <span class="has-text-weight-medium">
                    {{ timeAgo(t.created_at) }}
                  </span>
                </p>
                <p>
                  <i class="fa fa-coins fa-sm pad" />
                  <span>{{ currency }}{{ orderValue(t) }}</span>
                  <span v-if="isTukExpress(t)" class="tag has-text-link tuk-express">TUKExpress</span>
                </p>
              </div>
            </div>
            <div class="column is-1">
              <i class="fa fa-chevron-right fa-2x pulse" />
            </div>
          </div>
        </div>

        <div class="orders-header">
          <span class="is-size-5">
            <i class="fa fa-cog pad" :class="{ 'fa-spin': ongoingOrders.length }" />
            {{ $t("ecommerce.ongoing-orders") }}
          </span>
        </div>

        <!------------ Ongoing Orders ------------>
        <div v-if="ongoingOrders.length" style="margin-bottom: 10px">
          <div class="transaction" style="background-color: white" v-for="t in ongoingOrders" :key="t.id"
            @click="openOrderDetails(t)">
            <p class="state-tag-wrapper">
              <span v-if="isEdited(t)" class="tag edited"><i class="fa fa-pencil-alt" /></span>
              <span class="tag" :class="stateClass(t)">{{
                prettyState(t)
              }}</span>
            </p>
            <p v-if="t.data.order.fulfilment_time">
              <span class="scheduled-tag">
                <i class="far fa-hourglass has-text-white" style="padding-right: 3px" />
                {{ $t("ecommerce.scheduled-for") }}
                {{ t.data.order.fulfilment_time }}
              </span>
            </p>
            <div class="columns is-mobile is-vcentered">
              <div class="column is-narrow ticket">
                <p v-if="isTest(t)" class="test">TEST</p>
                <p class="is-size-3">{{ ref(t) }}</p>
                <i class="fa is-size-4" :class="fulfilmentIcon(t)" />
              </div>
              <div class="column middle">
                <div class="has-text-left">
                  <!-- <p v-if="t.data.order.fulfilment_time">
                        <span class="scheduled-tag">
                          <i class="far fa-hourglass pad has-text-white" />
                          {{ $t("ecommerce.scheduled-for") }}
                          {{ t.data.order.fulfilment_time }}
                        </span>
                      </p> -->
                  <p>
                    <i class="fa fa-user pad" />
                    {{ customerName(t) }}
                  </p>
                  <p>
                    <i class="far fa-clock pad" />
                    {{ $t("ecommerce.ordered") }}
                    <span class="has-text-weight-medium">
                      {{ timeAgo(t.created_at) }}
                    </span>
                  </p>
                  <p>
                    <i class="fa fa-coins pad" />
                    <span style="margin-left: 5px">{{ currency }}{{ orderValue(t) }}</span>
                    <!-- <span v-if="isEdited(t)" class="tag edited"><i class="fa fa-pencil-alt" /></span> -->
                    <span class="tag fulfilment">
                      {{ fulfilmentType(t) }}
                      <i v-if="isDelivery(t)" :class="deliveryClass(t.delivery)" style="margin-left: 4px">
                        {{ deliveryState(t) }}
                      </i>
                    </span>
                    <span v-if="isTukExpress(t)" class="tag has-text-link tuk-express">TUKExpress</span>
                  </p>
                </div>
              </div>
              <div class="column is-1">
                <i class="fa fa-angle-right fa-2x" />
              </div>
            </div>
          </div>
        </div>

        <div v-else class="notification is-white is-size-5 none">
          {{ $t("none") }}
        </div>

        <!-- <div style="height: 60px" /> -->

        <div class="orders-header">
          <span class="is-size-5" @click="forcePastOrders">
            <i class="fa fa-history pad" />
            {{ $t("ecommerce.past-orders") }}
          </span>
          <span class="is-pulled-right link" style="margin-right: 12px; font-weight: 500; color: #999" @click="viewMore">
            {{ $t("ecommerce.history") }}
          </span>
        </div>

        <!------------ Past Orders ------------>
        <div v-if="pastOrders.length" style="position: relative">
          <div :class="blurredClass">
            <div class="transaction" :class="invalidClass(t)" style="background-color: beige" v-for="t in pastOrders"
              :key="t.id" @click="openPastOrderDetails(t)">
              <p class="state-tag-wrapper">
                <span v-if="isEdited(t)" class="tag edited"><i class="fa fa-pencil-alt" /></span>
                <span class="tag" :class="stateClass(t)">{{
                  prettyState(t)
                }}</span>
              </p>
              <div class="columns is-mobile is-vcentered">
                <div class="column is-narrow ticket">
                  <p v-if="isTest(t)" class="test">TEST</p>
                  <p class="is-size-3">{{ ref(t) }}</p>
                  <i class="fa is-size-4" :class="fulfilmentIcon(t)" />
                </div>
                <div class="column middle">
                  <div class="has-text-left">
                    <p>
                      <i class="fa fa-user pad" />
                      {{ customerName(t) }}
                    </p>
                    <p>
                      <i class="far fa-clock pad" />
                      {{ $t("ecommerce.ordered") }}
                      <span v-if="isOld(t)" class="has-text-weight-medium">{{
                        prettyDate(t)
                      }}</span>
                      <span v-else class="has-text-weight-medium">
                        {{ timeAgo(t.created_at) }}
                      </span>
                    </p>
                    <p>
                      <i class="fa fa-coins pad" />
                      <span>{{ currency }}{{ orderValue(t) }}</span>
                      <!-- <span v-if="isEdited(t)" class="tag edited"><i class="fa fa-pencil-alt" /></span> -->
                      <span class="tag fulfilment">
                        {{ fulfilmentType(t) }}
                        <i v-if="isDelivery(t) && t.delivery" :class="deliveryClass(t.delivery)" style="margin-left: 4px">
                          {{ deliveryState(t) }}
                        </i>
                      </span>
                      <span v-if="isTukExpress(t)" class="tag has-text-link tuk-express">TUKExpress</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="notification is-white is-size-5 none">
          {{ $t("none") }}
        </div>

        <div style="text-align: center; margin: 20px">
          <span class="button is-rounded" @click="viewMore">{{
            $t("more")
          }}</span>
        </div>
        <div style="height: 300px" />
      </div>

      <footer class="bottom no-scrollbar">
        <div v-if="showChangeShopButton" class="column" @click="toggleChangeShop">
          <i class="fa fa-exchange-alt fa-lg" />
          <p>{{ $t("change") }}</p>
        </div>
        <div class="column" @click="viewShop">
          <i class="fa fa-store-alt fa-lg" />
          <p>{{ $t("home2.shop") }}</p>
        </div>
        <div v-if="!hideTUKExpress" class="column" @click="gotoExpress">
          <i class="fa fa-shipping-fast fa-lg" />
          <p>{{ $t("Express") }}</p>
        </div>
        <div class="column" @click="openCommerceSettings">
          <i class="fa fa-cog fa-lg" />
          <p>{{ $t("settings") }}</p>
        </div>
        <!-- <div
            class="column has-text-grey"
            @click="warningToast('Billing coming soon')"
          >
            <i class="fa fa-file-invoice fa-lg" />
            <p>{{ $t("commerce.billing") }}</p>
          </div>
          <div v-if="hasMembership" class="column" @click="showMembers = true">
            <i class="fa fa-address-card fa-lg" />
            <p>{{ $t("commerce.members") }}</p>
          </div>
          <div class="column" @click="showShare = true">
            <i class="fa fa-share-alt fa-lg" />
            <p>{{ $t("share") }}</p>
          </div> -->
      </footer>

      <!-- <fade-transition> -->
      <CommerceAgentShare v-if="showShare" :role="role" @close="showShare = false" />
      <!-- </fade-transition> -->

      <CommerceAgentNotifications v-if="showNotifications" :workflow="workflow" @close="showNotifications = false" />

      <EcommerceMorePanel v-show="showSidebar" @showMembers="showMembers = true" @showShare="showShare = true"
        @showNotifications="showNotifications = true" @showMenu="gotoDigitalMenu" @showSettings="showSettings = true"
        @close="showSidebar = false" />
    </div>

    <ChangeShopPanel v-if="showChangeShopPanel" :commerceAgentRoles="commerceAgentRoles" :currentRole="role"
      @close="showChangeShopPanel = false" @changeShopSuperuser="showChangeShop = true" />
  </div>
  <div v-else class="notification">
    <i class="fa fa-kiwi-bird" style="margin-bottom: 10px; font-size: 5em; color: brown" />
    <p class="title has-text-info">{{ $t("commerce.not-allowed") }}</p>
    <a class="button is-success" style="margin-top: 10px" @click="goHome">Go Home</a>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import MainBackButton from "@/components/MainBackButton.vue";
import CommerceSettings from "@/components/CommerceSettings.vue";
// import OrderDetailsModal from "@/components/OrderDetailsModal.vue";
import OrderDetailsCommerceAgent from "@/components/OrderDetailsCommerceAgent.vue";
import ChangeCommerceAgent from "@/components/ChangeCommerceAgent.vue";
import CommerceAgentShare from "@/components/CommerceAgentShare.vue";
import CommerceAgentNotifications from "@/components/CommerceAgentNotifications.vue";
import MembershipProgram from "@/components/MembershipProgram.vue";
import EcommerceMorePanel from "@/components/EcommerceMorePanel.vue";
import ChangeShopPanel from "@/components/ChangeShopPanel.vue";

import { sounds } from "../functions.js";
import pricing from "@/pricing";

export default {
  name: "Ecommerce",
  components: {
    MainBackButton,
    // OrderDetailsModal,
    OrderDetailsCommerceAgent,
    CommerceSettings,
    ChangeCommerceAgent,
    CommerceAgentShare,
    MembershipProgram,
    EcommerceMorePanel,
    CommerceAgentNotifications,
    ChangeShopPanel,
  },
  props: {
    id: String,
  },
  data() {
    return {
      showBilling: false,
      showChangeShopPanel: false,
      showSidebar: false,
      showMissingPicsCallout: true,
      showFBAdsCallout: false,
      showSetEmail: true,
      showMembers: false,
      showSettings: false,
      showShare: false,
      showNotifications: false,
      isBlurred: true,
      isUpdating: false,
      showChangeShop: false,
      showNotificationsHint: false,
      outOfStockCount: 0,
      missingPicCount: 0,
      completedItems: {},
      // isPaused: false,
      selected: null, // selected transaction
      width: 0, // screen width set on mounted
      z: 0, // force
      isDifferentTimezone: false,
    };
  },
  computed: {
    hasBilling() {
      var fruit = this.workflow.data.fruit;
      return pricing.billing(fruit);
    },
    deviceTimezone() {
      return new Date().getTimezoneOffset() / 60;
    },
    themeBgColor() {
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `background-color: ${bgColor}`;
    },
    themeColor() {
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `color: ${this.$h.textColor(bgColor)}`;
    },
    billingEmail() {
      return this.business.data.billing_email || this.business.data.email;
    },
    hideTUKExpress() {
      if (this.workflow.data.tuk_express) {
        return this.workflow.data.tuk_express.hide;
      }
      return false;
    },
    commerceAgentMessage() {
      // return `PLEASE PAUSE your shop and DO NOT ACCEPT delivery orders today if it's flooded in your area 🙏🏼
      // โปรดหยุดร้านของคุณชั่วคราวและไม่รับคำสั่งซื้อเดลิเวอรี่ในวันนี้หากน้ำท่วมในพื้นที่ของคุณ 🙏🏼`;
      return this.workflow.data.commerce_agent_message;
    },
    commerceAgentRoles() {
      return this.$store.state.roles.filter(
        (r) => r.role_name === "Commerce Agent"
      );
    },
    isPaused() {
      return this.workflow.data.paused;
    },
    showChangeShopButton() {
      return this.commerceAgentRoles.length > 1 || this.isSuperUser();
    },
    hasMembership() {
      return this.workflow.data.membership;
    },
    blurredClass() {
      if (this.isBlurred) return "blurred";
      return null;
    },
    // transactions() {
    //   return this.$store.getters.getRecentCustomerTransactions;
    // },
    role() {
      console.log("z role", this.z);
      return this.$store.getters.getCommerceAgentRole;
    },
    business() {
      return this.role.business;
    },
    currency() {
      return this.currencySymbol(this.role.business.country);
    },
    country() {
      return this.role.business.country;
    },
    newOrders() {
      return this.$store.getters.getCommerceAgentNewOrders;
    },
    ongoingOrders() {
      return this.$store.getters.getCommerceAgentOngoingOrders;
    },
    pastOrders() {
      console.log("z", this.z);
      return this.$store.getters.getCommerceAgentPastOrders;
      // return this.$store.state.pastCommerceAgentTransactions;
    },
    workflow() {
      return this.role.workflow;
    },
    updatedAt() {
      var dt = this.$store.state.commerceAgentTransactionsUpdatedAt;
      var time = this.hhmmTime(dt);
      return time;
      // return `${this.$t("updated")} ${time}`;
    },
    closedUntil() {
      if (!this.workflow.data.closed_until) return null;
      if (!this.isFutureTime(this.workflow.data.closed_until)) return null;
      return this.shortDateTime(this.workflow.data.closed_until);
    },
    // closedUntil() {
    //   if (!this.workflow.data.closed_until) return null;
    //   return this.shortDateTime(this.workflow.data.closed_until);
    // },
    todaysHours() {
      if (this.business.data.hours_type === "always-open") return "24 Hours";
      if (!this.business.data.hours) return "--Setup Hours--";
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" }); // timeZone: "America/New_York",
      var hours = this.business.data.hours[today.toLowerCase()];
      return hours || this.$t("shop.closed");
    },
    openClosed() {
      var open = { text: this.$t("shop.open"), class: "has-text-success" };
      var closed = { text: this.$t("shop.closed"), class: "has-text-danger" };
      var paused = { text: this.$t("shop.paused"), class: "has-text-warning" };
      if (this.isPaused) return paused;
      if (this.closedUntil) return closed;
      if (this.business.data.hours_type === "always-open") return open;
      if (!this.business.data.hours) return open; // unknown hours, say open
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" });
      var hours = this.business.data.hours[today.toLowerCase()];
      if (hours && this.openNow(hours)) return open;
      return closed;
    },
  },
  mounted() {
    this.checkPropID();
    this.width = window.innerWidth;
    // this.checkQuery(); // superuser
    this.updateOrdersCommerceAgent(false);
    setInterval(() => this.updateOrdersCommerceAgent(), 1000 * 90);

    EventBus.$on("ECOMMERCE_LOADER", (state) => (this.isUpdating = state));

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        EventBus.$emit("CLOSE_ORDER_DETAILS");
        this.updateOrdersCommerceAgent();
      }
    });

    if (!this.isSuperUser()) {
      this.startOnFavoriteCommerceAgentRole();
    }

    setTimeout(() => this.checkCommerceAgents(), 5000);
    setTimeout(() => this.checkDeviceTimezone(), 3000);
  },
  activated() {
    this.checkVersion();
    console.log("ECOMMERCE activated");
    this.updateOrdersCommerceAgent();
    this.checkOutOfStock();
    this.updateRoles(false); // to force update business and workflow info
    if (this.isSuperUser()) this.updateSuperRole(); // force update super role
    // also set this as your selectedBusiness
    // update business and workflows everytime
    this.$store
      .dispatch("getAndSelectBusiness", this.business.id)
      .catch((err) => this.apiError(err)); // // .then(() => this.setMetaThemeColor())
    this.$store
      .dispatch("getWorkflows", this.business.id)
      .catch((err) => this.apiError(err));
  },
  deactivated() {
    this.showSettings = false;
    this.showMembers = false;
    this.showShare = false;
    this.showNotifications = false;
    this.isBlurred = true;
    this.showChangeShop = false;
    this.showNotificationsHint = false;
    this.selected = null;
  },
  methods: {
    checkPropID() {
      if (this.id) alert("Prop: " + this.id);
    },
    checkDeviceTimezone() {
      var tz = new Date().getTimezoneOffset() / 60;
      var shopTZ = -7; // hard-code to thailand tz for now
      switch (this.country) {
        case "th":
          shopTZ = -7;
          break;
        case "sg":
          shopTZ = -8;
          break;
        default:
          shopTZ = -7;
      }
      if (tz === shopTZ) return; // same tz
      if (this.country !== "th") return; // skip non-thailand shops
      this.isDifferentTimezone = true;
    },
    isEdited(t) {
      if (!t.data.order || !t.data.order.basket) return;
      return t.data.order.basket.items.find((i) => i.item.id.startsWith("~"));
    },
    viewMore() {
      this.goto("/commerce_page/order-history");
      return;
    },
    gotoBilling() {
      var msg = this.$t("billing.if-paid-ignore");
      this.infoToast(msg, "top", 6000);
      // this.goto("commerce_page/billing");
    },
    infoHiddenShop() {
      var msg = `Contact your account manager<br>when your shop is ready to go LIVE`;
      this.infoToast(msg, "top", 9 * 1000);
    },
    startOnFavoriteCommerceAgentRole() {
      if (
        this.$store.getters.getFavoriteCommerceAgentRole &&
        this.$store.getters.getActiveCommerceAgentRole
      ) {
        if (
          this.$store.getters.getFavoriteCommerceAgentRole !==
          this.$store.getters.getActiveCommerceAgentRole
        ) {
          this.$store.commit("activateFavoriteCommerceAgentRole");
          this.$nextTick(() => {
            this.z += 1;
            this.updateOrdersCommerceAgent(true);
            var loader = this.loadingDots("blue");
            setTimeout(() => {
              loader.hide();
              var msg = "Changed to shop -<br>" + this.role.business.name;
              this.successToast(msg, "bottom");
            }, 2000);
          });
        }
      }
    },
    sendTestNotification() {
      var obj = this.$store.state.notification;
      if (obj && obj.created_at) return;
      if (!this.isProduction()) return;
      this.requestPushNotificationPermission();
      this.log("check_notifications", "commerce_agent");
      this.sendPushNotification("Order Notifications ON 👍🏼", this.userID());
    },
    isTest(t) {
      var notes = t.data.order.basket.notes;
      if (!notes) return false;
      return notes.includes("TEST ORDER");
    },
    isTukExpress(t) {
      return t.data.is_agent_order;
    },
    gotoDigitalMenu() {
      this.showMissingPicsCallout = false;
      this.showSettings = true;
      this.$nextTick(() => this.$refs.settings.editMenu());
      var loader = this.loadingDots("black");
      setTimeout(() => loader.hide(), 1000);
    },
    openFBAdsInfo() {
      this.showFBAdsCallout = false;
      this.showSettings = true;
      this.$nextTick(() => this.$refs.settings.facebookAds());
    },
    gotoExpress() {
      this.goto(`express/${this.role.business_id}`);
    },
    // gotoCommerceHome() {
    //   if (!this.isSuperUser()) return;
    //   this.goto(`commerce_home/${this.role.business_id}`);
    // },
    setBusinessEmail() {
      this.$swal({
        // title: this.$t("commerce.set-email-address"),
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'>
          <i class='fa fa-at'></i>&nbsp;
          ${this.$t("commerce.set-email-address")}
        </p>
        <p style='margin-top:12px'>${this.$t(
          "commerce.provide-your-business-email"
        )}</p>
        </div>`,
        input: "text",
        showCloseButton: true,
        confirmButtonText: this.$t("submit"),
        inputValidator: (txt) => {
          if (!txt) return `Enter e-mail`;
          if (txt.length < 4) return `Enter a valid e-mail`;
          if (!txt.includes("@")) return `Enter a valid e-mail`;
        },
      }).then((val) => {
        if (!val.value) return;
        this.sendEmail(val.value);
      });
    },
    sendEmail(email) {
      this.showSetEmail = false;
      var obj = {
        type: "set_billing_email",
        shop_name: this.business.name,
        email: email,
        user_id: this.$store.state.user.id,
        uuid: this.$store.getters.getUUID,
        mobile: this.$store.getters.phoneNumber,
        name: this.$store.getters.realName,
        app: process.env.VUE_APP_TITLE,
      };
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("sendEmail", obj)
        .then(() => {
          this.successToast("Thank you!<br>TUK will update your e-mail", "top");
        })
        .catch((err) => console.error(err))
        .finally(() => loader.hide());
    },
    checkCommerceAgents() {
      if (!this.isSuperUser()) return;
      this.$store
        .dispatch("getCommerceAgentsInfo", this.workflow.id)
        .then((res) => {
          if (!res.data) {
            this.errorToast("No Commerce Agents", "top", 1000 * 9);
            return;
          }
          var inactiveCnt = res.data.filter((r) => r.user).length;
          if (inactiveCnt) {
            var msg = `${inactiveCnt} Inactive Commerce Agents`;
            this.warningToast(msg, "top", 1000 * 9);
          }
        })
        .catch((err) => this.apiError(err));
    },
    preTogglePause() {
      if (this.workflow.data.paused) {
        this.togglePause();
      } else {
        var title = this.$t("pause-shop.pause-title");
        var para1 = this.$t("pause-shop.pause-para-1");
        var para2 = this.$t("pause-shop.pause-para-2");
        var para3 = this.$t("pause-shop.pause-para-3");
        this.$swal({
          html: `<div style='text-align:left'>
          <p style='font-size:1.2em'><i class='fa fa-pause-circle' style='margin-right:10px'></i>${title}</p>
          <p style='margin-top:10px'>${para1}</p>
          <p style='margin-top:10px'>${para2}</p>
          <p style='margin-top:10px'>${para3}</p>
          </div>`,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("pause-shop.pause-orders-now"),
          confirmButtonColor: this.bulmaColor("danger"),
          cancelButtonText: this.$t("cancel"),
        }).then((val) => {
          if (val.value) this.togglePause();
        });
      }
    },
    togglePause() {
      // this.isPaused = !this.isPaused;
      this.workflow.data.paused = !this.workflow.data.paused;
      var loader = this.loadingDots("palegreen");
      this.$store
        .dispatch("updateWorkflowData", {
          id: this.workflow.id,
          data: { paused: this.workflow.data.paused },
        })
        .then(() => {
          var state = this.$t("pause-shop.un-pause");
          if (this.workflow.data.paused) state = this.$t("pause-shop.pause");
          this.successToast(state);
          // this.updateRoles(false);
          this.z += 1; // necessary?
          // var msg = `${state} ${this.role.business.name}`;
          // this.sendSuperuserNotification(msg);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
      // this.$store
      //   .dispatch("updateWorkflow", {
      //     id: this.workflow.id,
      //     business_id: this.workflow.business_id,
      //     data: this.workflow.data,
      //   })
      //   .then(() => {
      //     var state = this.$t("pause-shop.un-pause");
      //     if (this.workflow.data.paused) state = this.$t("pause-shop.pause");
      //     this.successToast(state);
      //     // this.updateRoles(false);
      //     this.z += 1; // necessary?
      //     var msg = `${state} ${this.role.business.name}`;
      //     this.sendSuperuserNotification(msg);
      //   })
      //   .catch((err) => this.apiError(err))
      //   .finally(() => loader.hide());
    },
    updateSuperRole() {
      var payload = {
        workflow_type: "Commerce",
        business_id: this.business.id,
      };
      this.$store
        .dispatch("getBusinessAndWorkflow", payload)
        .then((res) => this.$store.commit("updateSuperRole", res.data))
        .catch((err) => this.apiError(err));
    },
    hoursDebug() {
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" });
      var hhmm = this.$date.getHHMM();
      var offset = new Date().getTimezoneOffset() / 60; // tz offset in hours
      var hours = this.business.data.hours[today.toLowerCase()];
      // if (hours && this.openNow(hours)) return open;
      var msg = `<div style='text-align:left'><strong>Hours debug</strong><br>
      closedUntil: ${this.closedUntil}<br>
      today: ${today}<br>
      hhmm: ${hhmm}<br>
      hours: ${hours}<br>
      offset: ${offset}<br>
      openNow: ${this.openNow(hours)}</div>`;
      this.infoToast(msg, "bottom", 10000);
    },
    toggleItemComplete({ transactionID, itemID }) {
      if (!this.completedItems[transactionID]) {
        this.completedItems[transactionID] = {};
      }
      var val = this.completedItems[transactionID][itemID];
      this.completedItems[transactionID][itemID] = !val;
    },
    checkOutOfStock() {
      // get digital_menu blob and count out of stock
      this.$store
        .dispatch("getDigitalMenuBlob", this.role.workflow_id)
        .then((res) => {
          console.log("getDigitalMenuBlob", res.data);
          if (!res.data) return;
          if (res.data.length > 1) {
            this.errorToast("Shop has more than 1 digital menu!", "top");
            var msg = `📚 👻 ${this.business.name} has more than 1 digital menu!`;
            this.sendSuperuserNotification(msg);
            return;
          }
          var m = res.data[0];
          this.outOfStockCount = m.data.filter((o) => o.out_of_stock).length;
          this.missingPicCount = m.data.filter((o) => !o.pic).length;
        })
        .catch((err) => this.apiError(err));
    },
    notify() {
      this.log("check_notifications", "commerce_agent");
      this.showNotificationsHint = true;
      sounds("navigate1");
      this.sendPushNotification("Hi from TUK 👍🏼", this.userID());
    },
    forcePastOrders() {
      this.z += 1; // don't know why this is necessary...but it is otherwise UI won't update until reload
    },
    toggleChangeShop() {
      this.showChangeShopPanel = true;
      return;
      // if (this.isSuperUser())  this.showChangeShop = !this.showChangeShop;
      // else this.activateNextRole();
    },
    activateNextRole() {
      // get index of current active role
      // set inactive and activate next role
      var activeRole = this.commerceAgentRoles.find((r) => r.active);
      var nextIdx = 1; // default next if no active role set
      if (activeRole) {
        // var idx = this.commerceAgentRoles.indexOf(this.id === activeRole.id);
        var idx = this.commerceAgentRoles
          .map((r) => r.id)
          .indexOf(activeRole.id);
        console.log("idx", idx);
        var maxIdx = this.commerceAgentRoles.length - 1;
        nextIdx = idx + 1;
        if (nextIdx > maxIdx) nextIdx = 0;
      }
      this.$store.commit("clearCommerceAgentTransactions");
      this.$store.commit("activateCommerceAgentRole", nextIdx);
      this.$nextTick(() => {
        this.z += 1;
        this.updateOrdersCommerceAgent(true);
        console.log("idx", nextIdx, this.role.business.name);
        var loader = this.loadingDots("blue");
        setTimeout(() => {
          loader.hide();
          var msg = "Changed to shop:<br>" + this.role.business.name;
          this.successToast(msg, "bottom");
        }, 2000);
      });
      sounds("navigate1");
    },
    viewShop() {
      this.$router.push(`/shop/${this.role.business_id}?tab=info`);
    },
    ref(t) {
      if (t.data.ref_prefix) {
        return t.data.ref_prefix + t.data.ref;
      }
      return "#" + t.data.ref;
    },
    customerName(t) {
      if (!t.customer) return "ERR";
      var name = t.customer.name || t.customer.phone_number;
      return this.shortenString(name, 20);
    },
    invalidClass(t) {
      var invalidStates = [
        "timed_out",
        "cancelled_by_shop",
        "cancelled_by_customer",
      ];
      if (invalidStates.includes(t.state)) return "invalid";
      return null;
    },
    isDelivery(t) {
      return t.data.type === "delivery";
    },
    deliveryState(t) {
      if (!t.delivery) {
        if (t.is_ongoing) return this.$t("pending");
        else return this.$t("none");
      }
      var state = t.delivery.state;
      if (state.startsWith("cancelled")) return "Cancelled";
      return this.translateState(state);
    },
    fulfilmentIcon(t) {
      var type = t.data.type;
      if (type === "take-away") return "fa-walking  has-text-link";
      if (type === "delivery") return "fa-shipping-fast";
      if (type === "dine-in") return "fa-users has-text-orange";
      return "fa-question has-text-danger";
    },
    fulfilmentType(t) {
      return this.translateFulfilmentType(t.data.type);
    },
    isOld(t) {
      return this.hoursAgo(t.created_at) > 48;
    },
    prettyDate(t) {
      var dt = new Date(t.created_at);
      return dt.toLocaleDateString();
    },
    newOrderStyle(t) {
      var color = this.bulmaColor("warning");
      if (this.secondsAgo(t.created_at) > 180)
        color = this.bulmaColor("danger");
      return `background-color:${color}`;
    },
    gotoHours() {
      this.goto("/commerce_page/set-hours");
    },
    openCommerceSettings() {
      this.showSettings = true;
      // this.displayModal(".commerce-settings-modal");
      // EventBus.$emit("OPEN_COMMERCE_SETTINGS");
    },
    openOrderDetails(t) {
      this.goto(`commerce_agent_order/${t.id}`);
    },
    openPastOrderDetails(t) {
      if (this.isBlurred) {
        this.isBlurred = false;
        setTimeout(() => (this.isBlurred = true), 15 * 1000);
        return;
      }
      this.openOrderDetails(t);
    },
    prettyState(t) {
      if (t.state === "confirmed") return this.$t("ecommerce.being-prepared");
      if (t.state === "ready") return this.$t("ecommerce.waiting-for-pickup"); // if take-away
      if (t.state === "completed") return this.$t("ecommerce.completed");
      if (t.state === "timed_out") return this.$t("ecommerce.expired");
      if (t.state === "cancelled_by_shop")
        return this.$t("ecommerce.shop-cancelled");
      if (t.state === "cancelled_by_customer")
        return this.$t("ecommerce.customer-cancelled");
      return t.state; // else return unknown state without translating
    },
    stateClass(t) {
      if (!t) return "is-white"; // in case delivery txn not set on commerce txn yet
      var tagClass = "is-dark";
      if (t.state === "confirmed") tagClass = "is-warning";
      if (t.state === "ready") tagClass = "is-orange";
      if (t.state === "completed") tagClass = "is-success";
      if (t.state === "cancelled_by_shop") tagClass = "is-danger";
      if (t.state === "cancelled_by_customer") tagClass = "is-danger";
      if (t.state === "timed_out") tagClass = "is-danger";
      // delivery specific:
      if (t.state === "alighted") tagClass = "is-success";
      if (t.state === "driver_arrived") tagClass = "is-link";
      if (t.state === "enroute") tagClass = "is-primary";
      return tagClass;
    },
    deliveryClass(t) {
      if (!t) return "has-text-grey"; // shouldn't happen
      if (t.state === "confirmed") return "has-text-info";
      if (t.state === "cancelled_by_shop") return "has-text-danger";
      if (t.state === "timed_out") return "has-text-danger";
      if (t.state === "alighted") return "has-text-success";
      if (t.state === "driver_arrived") return "has-text-link";
      if (t.state === "enroute") return "has-text-primary";
      return null;
    },
    lalamoveFee(t) {
      if (t.data.type !== "delivery") return null;
      if (!t.data.delivery.lalamove) return null;
      return t.data.fare.price;
    },
    orderValue(t) {
      // add fees and discounts
      var discounts = t.data.order.special_discount || 0;
      var vat = t.data.order.vat || 0;
      var orderValue = t.data.order.order_value + vat - discounts;
      if (t.data.type === "delivery" && t.data.fare) {
        var deliveryFee = t.data.fare.price;
        if (this.lalamoveFee(t)) orderValue += deliveryFee;
        // if (t.data.delivery.is_free_delivery) orderValue -= deliveryFee;
        //  else if (t.data.order.delivery_subsidy) orderValue -= t.data.order.delivery_subsidy;
        orderValue -= t.data.order.delivery_subsidy;
        orderValue -= t.data.order.remit || 0;
      }
      return orderValue;
    },
  },
};
</script>

<style scoped>
.ecommerce {
  max-height: 100vh;
  overflow: hidden;
  text-align: left;
}

.wrapper {
  max-width: 600px;
  margin: 0 auto;
}

.wrapper-border {
  border: 1px solid #eee;
}

.bg-red {
  background-color: rgba(255, 0, 0, 0.5);
}

.header {
  line-height: 56px;
  padding-left: 55px;
  /* margin-bottom: 0px; */
  /* margin-top: 2px; */
  max-width: calc(100vw - 42px);
  /* text-overflow: ; */
  overflow-y: hidden;
  display: inline-block;
  white-space: nowrap;
  font-weight: 450;
  /* color: white; */
  font-size: 1.2em;
  /* color: gainsboro; */
}

.transaction {
  position: relative;
  border-radius: 2px;
  /* border: 1px solid lightgrey; */
  box-shadow: 0px 0px 2px lightgrey;
  /* margin: 3px; */
  margin-bottom: 4px;
}

.fa-window-minimize {
  position: relative;
  top: -4px;
}

.fa-chevron-right,
.fa-angle-right {
  opacity: 0.6;
}

.columns {
  margin: 0 4px;
  /* padding: 4px; */
}

.column.is-1 {
  padding: 0 0;
}

.column.middle {
  padding-right: 0;
}

.column.is-narrow {
  text-align: center;
}

hr {
  /* margin: 0px -26px 0px; */
  margin: 0 6px 0;
  border-bottom: 1px solid lightgrey;
}

/* body { margin: 2em; } */
p {
  margin-bottom: 0px !important;
}

.ticket {
  background-color: azure;
  border: 2px dotted grey;
  border-radius: 2px;
  padding: 4px;
  font-family: "Bookman Old Style", "Times New Roman", Times, serif;
}

.ticket p {
  font-weight: 600;
}

.pad {
  margin-right: 8px;
  opacity: 0.7;
  font-size: 0.9em;
}

.tag {
  padding: 0 6px;
}

.un-pause {
  background-color: lightgreen;
  padding-left: 9px;
  padding-right: 0;
  border-radius: 10px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  color: black;
}

.pulse {
  padding: 3px;
  border-radius: 50%;
  animation: shadow-pulse-gold 1s infinite;
}

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 255, 255, 0.95);
  }

  100% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.05);
  }
}

.pulse-orange {
  padding: 3px;
  border-radius: 50%;
  animation: shadow-pulse-orange 1s infinite;
}

@keyframes shadow-pulse-orange {
  0% {
    box-shadow: 0 0 0 0px rgba(248, 211, 2, 0.95);
  }

  100% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.05);
  }
}

.is-orange {
  background-color: orange;
}

.buttons {
  padding-bottom: 0;
}

.button {
  margin-bottom: 0;
}

.invalid {
  background: repeating-linear-gradient(45deg,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.1) 10px,
      rgba(253, 101, 101, 0.2) 10px,
      rgba(253, 101, 101, 0.2) 20px
      /* rgba(0, 0, 0, 0) 10px,
    rgba(0, 0, 0, 0) 20px */
    );
}

.blurred {
  filter: blur(3px);
}

.orange-btn {
  color: orange;
  border-color: orange;
  background-color: transparent;
}

.state-tag-wrapper {
  position: absolute;
  right: 5px;
  top: 5px;
  font-weight: 500;
}

.state-tag {
  position: absolute;
  right: 5px;
  top: 5px;
  font-weight: 500;
}

.none {
  text-align: center;
  padding: 12px;
  margin: 0;
  font-weight: 550;
  border-radius: 0;
  color: rgba(0, 0, 0, 0.35);
}

.no-radius {
  border-radius: 0;
}

.test-notification {
  position: fixed;
  z-index: 2;
  text-align: left;
  padding: 16px;
  margin: 0;
  /* font-weight: 550;
  color: rgba(0, 0, 0, 0.35); */
}

.test-notification p {
  padding-bottom: 12px;
}

.bottom {
  position: absolute;
  bottom: 0;
  /* left: 0; */
  height: 70px;
  /* min-width: 100vw; */
  width: 100%;
  max-width: 600px;
  background-color: rgba(255, 255, 255, 0.97);
  padding-bottom: 20px;
  padding-top: 16px;
  padding-left: 10px;
  padding-right: 10px;
  /* box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.35); */
  z-index: 3;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  font-size: 0.9em;
  text-align: center;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.35);
  clip-path: inset(-3px 0px 0px 0px);
  /* box-shadow: 0px -5px 0px 0px #eee; */
}

.bottom .column {
  display: inline-block;
  width: 80px;
  padding: 0 0;
}

.oos-btn {
  position: absolute;
  right: -5px;
  margin-top: -3px;
  padding-left: 8px;
  padding-right: 6px;
  box-shadow: 0 0 1px grey;
}

.oos-cnt {
  padding: 0px 6px;
  margin-left: 4px;
  margin-right: -4px;
  background-color: red;
  border-radius: 10px;
  color: white;
  font-size: 1.2em;
}

.hours-wrapper {
  margin: 20px 12px 16px 16px;
  font-weight: 500;
  position: relative;
  /* background-color: white; */
}

.open-hours {
  display: inline-block;
  max-width: calc(100vw - 150px);
  white-space: nowrap;
  overflow: auto;
}

.pause-btn {
  float: right;
  padding-right: 12px;
  font-weight: 500;
  color: #999;
}

.paused.notification {
  font-weight: 500;
  color: black;
  background-color: lightgreen;
  margin: 10px;
  box-shadow: 1px 1px 3px black;
}

.billing-check-email {
  font-weight: 400;

}

.billing-btn {
  font-weight: 500;
  color: black;
  margin: 10px;
  box-shadow: 1px 1px 3px black;
}

.link {
  border-bottom: 1px #ccc dotted;
}

.link-dark {
  border-bottom: 1px black dotted;
}

.notification {
  padding: 10px;
  margin-bottom: 10px;
}

.pulse-background {
  border-radius: 0;
  background-color: pink;
  animation-name: bgColorPulse;
  animation-duration: 2s;
  animation-iteration-count: 10;
}

@keyframes bgColorPulse {
  0% {
    background-color: pink;
  }

  40% {
    background-color: red;
  }

  80% {
    background-color: gold;
  }

  100% {
    background-color: gold;
  }
}

.pulse-btn {
  border-radius: 25px;
  animation: shadow-pulse-gold 2s ease-out infinite;
}

@keyframes shadow-pulse-gold {
  0% {
    box-shadow: inset 0 0 0 0px rgb(0, 255, 100);
  }

  50% {
    box-shadow: inset 0 0 0 14px rgba(0, 255, 0, 0.7);
  }

  100% {
    box-shadow: inset 0 0 0 0px rgba(0, 255, 255, 1);
  }
}

.tag.fulfilment {
  box-shadow: 0 0 2px grey;
  margin-left: 6px;
  font-weight: 500;
}

.tag.edited {
  box-shadow: 0 0 1px grey;
  margin-right: 6px;
  color: var(--info);
}

.test {
  color: red;
  position: absolute;
  font-family: sans-serif;
  background-color: yellow;
  text-align: center;
  left: 0;
  top: 0;
  padding: 2px 4px;
  margin: 2px;
  line-height: 1em;
  font-size: 10pt;
  border-radius: 2px;
  /* box-shadow: 1px 1px 3px grey; */
  border: 1px solid red;
}

.more-btn {
  /* background-color: grey; */
  border-radius: 50px;
  /* box-shadow: 0 0 2px grey; */
}

.top-bar {
  position: absolute;
  top: 0;
  width: 100vw;
  max-width: 600px;
  height: 56px;
  /* background-color: lightgrey; */
  background-color: rgb(59, 59, 59);
  z-index: 0;
}

.header-row {
  position: relative;
  /* margin-top: 15px; */
  height: 56px;
  z-index: 2;
  /* color: #999; */
  color: gainsboro;
}

.closed-until {
  background-color: rgb(255, 67, 67);
  color: white;
  text-shadow: 0 0 1px black;
  border-radius: 3px;
  padding: 0 3px;
  font-size: 0.85em;
}

.orders-header {
  padding-left: 16px;
  padding-bottom: 10px;
}

.orders-header .is-size-5 {
  font-weight: 500;
}

.tuk-express {
  font-weight: 500;
  background-color: var(--warning);
  border: 1px solid var(--link);
  /* float: right; */
  margin-left: 4px;
}

.scheduled-tag {
  color: var(--danger);
  font-weight: 500;
  background-color: black;
  border-radius: 3px;
  padding: 0 6px;
  /* margin-left: -2px; */
  margin-left: 4px;
  margin-top: 5px;
  display: inline-block;
}
</style>